import { render, staticRenderFns } from "./documentModelEdit.vue?vue&type=template&id=0e83fa09&scoped=true&"
import script from "./documentModelEdit.vue?vue&type=script&lang=js&"
export * from "./documentModelEdit.vue?vue&type=script&lang=js&"
import style0 from "./documentModelEdit.vue?vue&type=style&index=0&id=0e83fa09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83fa09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e83fa09')) {
      api.createRecord('0e83fa09', component.options)
    } else {
      api.reload('0e83fa09', component.options)
    }
    module.hot.accept("./documentModelEdit.vue?vue&type=template&id=0e83fa09&scoped=true&", function () {
      api.rerender('0e83fa09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/documentModelEdit.vue"
export default component.exports